// default export
const getImagePath = (vertical = '') => {
  const verticalName = vertical.toUpperCase();
  switch (verticalName) {
    case 'ABUJA':
    case 'NIGER':
      return '/img/discos/ABUJA.png';
    case 'ABA':
    case 'ABAPOWER':
    case 'APLE':
      return '/img/discos/ABA.svg';
    case 'BENIN':
      return '/img/discos/BENIN.svg';
    case 'EKEDC':
    case 'EKO':
      return '/img/discos/EKEDC.png';
    case 'IBADAN':
      return '/img/discos/IBEDC.png';
    case 'IKEJA':
      return '/img/discos/IKEDC.png';
    case 'JOS':
      return '/img/discos/JOS.png';
    case 'KADUNA':
    case 'KAIDA':
      return '/img/discos/KAEDCO.png';
    case 'KANO':
      return '/img/discos/KEDCO.png';
    case 'ENUGU':
      return '/img/discos/EEDC.png';
    case 'YOLA':
      return '/img/discos/YOLA.png';
    case 'PHED':
    case 'PH':
      return '/img/discos/PHED.png';
    case 'MTN':
      return '/img/discos/MTN.svg';
    case 'GLO':
      return '/img/discos/GLO.svg';
    case 'AIRTEL':
      return '/img/discos/AIRTEL.svg';
    case '9MOBILE':
      return '/img/discos/9MOBILE.svg';
    case 'DSTV':
      return '/img/discos/DSTV.svg';
    case 'GOTV':
      return '/img/discos/GOTV.svg';
    case 'STARTIMES':
      return '/img/discos/STARTIMES.svg';
    case 'ELECTRICITY':
      return '/img/discos/ELECTRICITY.png';
    case 'AIRTIME':
      return '/img/discos/AIRTIME.svg';
    case 'CABLE':
      return '/img/discos/CABLE.svg';
    case 'DATA':
      return '/img/discos/DATA.svg';
    default:
      return '/img/buypower.png';
  }
};

export default getImagePath;
